import lessonTypes from '../lessonTypes'

export default {
	[lessonTypes.REGULAR]: 'Slide',
	[lessonTypes.VIDEO]: 'Video',
	[lessonTypes.QUICK_LAUNCH]: 'Quick Launch',
}
